import { getCurrentPath } from "@faire/web--source/common/Path";

export const persistUrlParams = (url: string, deleteParams?: string[]) => {
  const urlObject = getCurrentPath();
  if (deleteParams) {
    deleteParams.forEach((param) => {
      urlObject.delete(param);
    });
  }
  const params = urlObject.searchParams.toString();
  if (!params) {
    return url;
  }
  const persistedUrl = `${url}?${params}`;
  return persistedUrl;
};
